import { authHeader, handleResponse } from "../helpers";
export const catalogueMasterService = {
  GetCatalogues,
  UpsertCatalogueHeader,
  UpsertCatalogueDetails,
};

function GetCatalogues(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Catalogue/GetCatalogues`,
    requestOptions,
  ).then(handleResponse);
}

function UpsertCatalogueHeader(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Catalogue/UpsertCatalogueHeader`,
    requestOptions,
  ).then(handleResponse);
}

function UpsertCatalogueDetails(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}Catalogue/UpsertCatalogueDetails`,
    requestOptions,
  ).then(handleResponse);
}
